export default {
  aboutUsContent:
  'Welcome to MiPeso, your gateway to a convenient and secure cash loan experience. We are dedicated to offering the Filipino community exceptional cash loan services with transparent fees and a straightforward application process. Our platform allows you to swiftly evaluate your eligibility by inputting your information, all while our state-of-the-art encryption technology keeps your privacy safe and secure.\n' +
    'With MiPeso, you have the flexibility to update your payment account information at any time. Accessing your loan history is a breeze, and our contact and feedback center are just a tap away, ensuring you can easily communicate with our dedicated CS team.\n' +
    '\n' +
    'Discover more about us:\n' +
    'Company: Lucky Shell Fintech Lending Inc. (SEC Registration No. CS201912995, CA No. 3055)\n' +
    'Address: {address}\n' +
    'Customer Service: {tel}',
};
